import { render, staticRenderFns } from "./firmakartinagore.vue?vue&type=template&id=1d84aee9&scoped=true"
import script from "./firmakartinagore.vue?vue&type=script&lang=js"
export * from "./firmakartinagore.vue?vue&type=script&lang=js"
import style0 from "./firmakartinagore.vue?vue&type=style&index=0&id=1d84aee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84aee9",
  null
  
)

export default component.exports